import * as ActionTypes from './actionTypes'

export const NAME = 'search'

const initialState = {
  query: '',
  results: [],
  showResults: {},
  isSearching: false,
  hasSearched: false
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.SET_QUERY:
      return {
        ...state,
        query: action.query
      }
    case ActionTypes.START_SEARCH:
      return {
        ...state,
        results: [],
        isSearching: true
      }
    case ActionTypes.END_SEARCH:
      return {
        ...state,
        isSearching: false,
        hasSearched: true
      }
    case ActionTypes.ADD_RESULTS:
      if (state.results.length > 0) {
        return {
          ...state,
          results: [action.results, ...state.results]
        }
      } else {
        action.results.showResults = true
        return {
          ...state,
          showResults: { ...state.showResults, [action.mapId]: true },
          results: [action.results]
        }
      }
    case ActionTypes.SHOW_RESULTS:
      return { ...state, showResults: { ...state.showResults, [action.id]: true } }
    case ActionTypes.HIDE_RESULTS:
      return { ...state, showResults: { ...state.showResults, [action.id]: false } }
    case ActionTypes.CLEAR_SEARCH:
      return initialState
    default:
      return state
  }
}

export default reducer